import { createFileRoute, redirect } from '@tanstack/react-router'

import { DashboardScreen } from '@/features/dashboard/DashboardScreen'
import { homeRedirect } from '@/features/preferences/home'
import { atTheShelf } from '@/features/shelf/posture'

export const Route = createFileRoute('/')({
  beforeLoad: () => {
    // A phone at the shelf opens on the shelf (D33); "Full Fundus" opts out.
    if (atTheShelf()) throw redirect({ to: '/shelf', replace: true })
    const to = homeRedirect()
    if (to) throw redirect({ to, replace: true })
  },
  component: DashboardPage,
})

function DashboardPage() {
  return <DashboardScreen />
}
